<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente icono-titulo="fas fa-plus" texto-titulo="Nuevo Concepto" />
      <div class="tab-content">
        <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarConcepto()">
                    <float-label label="Código:" clase="col-12">
                      <input
                        id="codigo"
                        v-model="concepto.codigo"
                        placeholder="Ingresar código..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                        :class="(enviado && !$v.concepto.codigo.required) ? 'is-invalid' : ''"
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.concepto.codigo.required"
                        >Debe ingresar el código</div>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.concepto.codigo.numeric"
                        >Sólo se aceptan números</div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase="col-12">
                      <input
                        id="descripcion"
                        v-model="concepto.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                        :class="(enviado && !$v.concepto.descripcion.required) ? 'is-invalid' : ''"
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.concepto.descripcion.required"
                        >Debe ingresar la descripción</div>
                      </template>
                    </float-label>
                    <float-label label="Tipo:" clase="col-12">
                      <select
                        class="form-control"
                        :class="(enviado && !$v.concepto.tipo.required) ? 'is-invalid' : ''"
                        id="tipo"
                        v-model="concepto.tipo"
                        placeholder="Tipo"
                      >
                        <option :value="''">Seleccione el tipo</option>
                        <option value="Remunerativo">Remunerativo</option>
                        <option value="No remunerativo">No remunerativo</option>
                        <option value="Retención">Retención</option>
                        <option value="Asignación familiar">Asignación familiar</option>
                        <option value="Puente">Puente</option>
                        <option value="Redondeo">Redondeo</option>
                        <option value="Contribución patronal">Contribución patronal</option>
                      </select>
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.concepto.tipo.required"
                        >Debe seleccionar el tipo</div>
                      </template>
                    </float-label>

                    <float-label label="Código AFIP:" clase="col-12">
                      <input
                        id="codigo_afip"
                        v-model="concepto.codigo_afip"
                        placeholder="Ingresar código de afip..."
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                      />
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">Guardar</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import Swal from "sweetalert2";
import Concepto from "@/models/concepto";
import { required, numeric } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  name: "NuevoConcepto",
  components: {
    TituloComponente,
    FloatLabel,
  },
  data() {
    return {
      concepto: new Concepto(null, null, "", "", null),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    concepto: {
      codigo: { required, numeric },
      descripcion: { required },
      tipo: { required },
    },
  },
  mounted(){
        this.ultimoConcepto();
  },
  methods: {
    ultimoConcepto(){
      axios.get("ultimo-concepto/").then((res) => {
            this.concepto.codigo = parseInt(res.data.concepto.codigo)+1
        }).catch(() => {

        }).finally(() => {
          this.loading = false;
        });
    },
    guardarConcepto() {
      this.enviado = true;
      this.$v.$touch();
      this.loading = true;
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .post("/conceptos", this.concepto)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarConceptos" });
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.concepto.descripcion} se guardó con éxito.`,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oopss..",
              text: `No se ha podido completar la operación.`,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
